/**
 * Http Wrapper for the request.
 * This service adds headers, token etc for every request. If a bare request needs to be made,
 * consider using HttpClient instead.
 */
import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {AppStateService} from './app.state.service';
import {ErrorHelper} from '../_handlers/error.handler';
import {AppResponse} from '../_modals/app.response';
import {catchError, map} from 'rxjs/operators';
import {Authentication} from '../_modals/auth.response';
import {start} from 'repl';
import {from} from 'rxjs';

@Injectable()
export class HttpService {
    public ddb;
    public dd;
    public userkey;
    headers;
    baseUrl: string = environment.baseUrl;
    public Server_prefix = 'TPH4';

    constructor(private http: HttpClient, private appState: AppStateService,
                private errorHelper: ErrorHelper) {
        let AWS = require('aws-sdk');
        AWS.config.update({region: environment.region,
            accessKeyId:  environment.akstr,
            secretAccessKey: environment.skstr
        });
        this.ddb = new AWS.DynamoDB.DocumentClient();
        this.dd = new AWS.DynamoDB();
        this.headers = new HttpHeaders();
        this.userkey = {'Authorization': 'ApiKey jnadmin:bcb9df6a2cc2f2c8944c3820fe6bdc5954d1facb'};
    }

    async getGeneral(ai: string) {
        let table = 'Ai_properties';
        let pkey = this.Server_prefix + '-ai-' + ai;
        let skey = 'General';
        let params = {
            TableName: table,
            KeyConditionExpression: 'pkey = :v_pkey and skey = :v_skey',
            'ExpressionAttributeValues': {
                ':v_skey': skey,
                ':v_pkey': pkey
            },
        };
        let get_data;
        let request = await this.ddb.query(params);
        await request.promise().then(function(data) {
            get_data =  data;
        });
        return get_data;
    }

    async getStaticData() {
        let table = 'Ai_properties';
        let pkey = this.Server_prefix + '-mnews-static';
        let params = {
            TableName: table,
            KeyConditionExpression: 'pkey = :v_pkey',
            'ExpressionAttributeValues': {
                ':v_pkey': pkey
            },
        };
        let get_data;
        let request = await this.ddb.query(params);
        await request.promise().then(function(data) {
            get_data =  data;
        });
        return get_data;
    }

    async getBatchData(item_list, ai, channel) {
        let pkey = 'TPH4-ai-' + ai;
        let array = [];
        for (let i = 0; i < item_list.length; i++) {
            let dict = {
                'pkey': pkey,
                'skey': item_list[i].toString()
            };
            array.push(dict);
        }
        let table = 'Items';
        let params = {
            'RequestItems' : {
                'Items' : {
                    'Keys' : array
                }
            }
        };
        let get_data;
        let request = await this.ddb.batchGet(params);
        await request.promise().then(function(data) {
            get_data =  data;
        });
        return get_data;
    }

    async getItem_UNM(ai, channel, state) {
        let table = 'Items';
        let pkey = 'TPH4-ai-' + ai;
        let params = {
            TableName: table,
            IndexName: 'localindex',
            KeyConditionExpression: 'pkey = :v_pkey and begins_with (lskey , :v_start)',
            Limit: 20,
            'ExpressionAttributeValues': {
                ':v_start': 'ch-' + channel + '-0-' + state,
                ':v_pkey': pkey
            },
            // FilterExpression: "is_comment = :v_comment",
            ScanIndexForward: false,
        };
        let a;
        let request = await this.ddb.query(params);
        await request.promise().then(function(data) {
            a =  data;
        });
        return a;
    }

    async getAPI(callerid) {
        let table = 'Ai_properties';
        let pkey = 'TPH4-user';
        let skey = 'msisdn-' + callerid;
        let params = {
            TableName: table,
            KeyConditionExpression: 'pkey = :v_pkey and skey = :v_skey',
            'ExpressionAttributeValues': {
                ':v_skey': skey,
                ':v_pkey': pkey
            },
        };
        let get_data;
        let request = await this.ddb.query(params);
        await request.promise().then(function(data) {
            get_data = data;
        });
        return get_data;
    }

    uploadsm_image(news, file) {
        const formData: FormData = new FormData();
        formData.append('news_id', news);
        formData.append('image_file', file);
        const url = this.baseUrl + 'mnews_news/upload_sm_image/';
        return this.http.post<any>(url, formData, {headers: this.userkey});
    }

    uploadAudio(news, file) {
        const formData: FormData = new FormData();
        formData.append('news_id', news.id);
        formData.append('ai_id', news.ai);
        formData.append('audio_file', file);
        if (news.detail) {
            formData.append('recording_id', news.detail);
        }
        const url = this.baseUrl + 'mnews_news/upload_audio/';
        return this.http.post<any>(url, formData, {headers: this.userkey});
    }

    updateOnAssignGrievnace(state, grievance_id, quitreason_id, file) {
        const formData: FormData = new FormData();
        formData.append('state', state);
        formData.append('grievance_id', grievance_id);
        formData.append('audio_file', file);
        formData.append('quitreason_id', quitreason_id);
        const url = this.baseUrl + 'casemanager/grievance/update_on_grievance_distmod/';
        return this.http.post<any>(url, formData, {headers: this.userkey});
    }

    ElasticSearch(searchFields) {
        let states = [];
        let query_array = [];
        let range_date;
        let callerids;
        let tags = '';
        let autoTags = '';

        query_array.push({'query_string': {'fields': ['ai'], 'query': searchFields.ai_id}});
        query_array.push({'query_string': {'fields': ['server'], 'query': 'TPH4'}});
        query_array.push({'query_string': {'fields': ['is_comment'], 'query': 'false'}});

        if (searchFields.states) {
            query_array.push({'terms' : {'state.keyword': searchFields.states}});
        }

        for (let key in searchFields.auto_state) {
            if (searchFields.auto_state.hasOwnProperty(key)) {
                autoTags = autoTags.concat(searchFields.auto_state[key], ',');
            }
        }
        if (autoTags !== '') {
            // tslint:disable-next-line:max-line-length
            let tag = autoTags.replace(/,/g , ' ').replace(/#/g, ' ').replace(/-/g, ' ').replace(/:/g, ' ').replace(/;/g, ' ').replace(/_/g, ' ');
            query_array.push({'query_string': {'fields': ['tags'], 'query': tag}});
        }

        // search by tags
        if (searchFields.tags || tags !== '') {

            // tslint:disable-next-line:max-line-length
            tags = (searchFields.tags);
            // tslint:disable-next-line:max-line-length
            let tag = tags.replace(/,/g , ' ').replace(/#/g, ' ').replace(/-/g, ' ').replace(/:/g, ' ').replace(/;/g, ' ').replace(/_/g, ' ');
            query_array.push({'query_string': {'fields': ['tags'], 'query': tag, 'default_operator': 'AND'}});
        }
        // search by phone num
        if (searchFields.callerId) {
            callerids = searchFields.callerId.replace(/,/g , ' ');
            query_array.push({'query_string': {'fields': ['callerid'], 'query': callerids}});
        }

        if (!searchFields.start_date || !searchFields.end_date) {
            range_date = {'range': {'time': {'lte': 'now+1d'}}};
        } else {
            range_date = {'range': {'time': {'gte': searchFields.start_date, 'lte': searchFields.end_date}}};
            query_array.push(range_date);
        }

        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        const url = 'http://ml.gramvaani.org/tph4/item/_search';
        let params2 = {
            'size': 20,
            'query': {
                'bool': {
                    'must': query_array
                }
            },
            '_source': ['skey', 'pkey', 'rating'],
            'sort': [{'time': {'order': 'desc'}}]
        };
        return this.http.post<any>(url, params2, {headers: headers}) as any;

    }

    post<T>(url: string, data: any, params?: any, isFormEncoded?: boolean) {
        let headers = new HttpHeaders();
        headers = headers.set('Content-type', 'application/json');
        const options = {headers};
        if (url === '') {
            url = 'mnews_news/news_save_item/';
        }
        if (params)
            options['params'] = this.addQueryParameters(params);
        return this.http.post<AppResponse>(this.baseUrl + url, data, {headers: this.userkey})
            .pipe(
                catchError(e => this.errorHelper.handleError(e)),
                map(r => this.errorHelper.mapToError(r)),
                map(tr => <T>tr)
            );
    }

    get<T>(url: string, params?: any, isFormEncoded?: boolean) {
        let options = this.getRequestOption(isFormEncoded);
        if (params)
            options['params'] = this.addQueryParameters(params);
        return this.http.get<AppResponse>(this.baseUrl + url, options)
            .pipe(
                catchError(e => this.errorHelper.handleError(e)),
                map(r => this.errorHelper.mapToError(r)),
                map(tr => {
                    return tr;
                })
            );
    }

    async get_perm_roles(role) {
        let table = 'Ai_properties';
        let pkey = 'GLOBAL-dm-roles';
        let skey = role;
        let params = {
            TableName: table,
            KeyConditionExpression: 'pkey = :v_pkey and skey = :v_skey',
            'ExpressionAttributeValues': {
                ':v_skey': skey,
                ':v_pkey': pkey
            },
        };
        let get_data;
        let request = await this.ddb.query(params);
        await request.promise().then(function(data) {
            get_data = data;
        });
        return get_data.Items[0].perm;
    }

    private addQueryParameters(params) {
        let qParams: HttpParams = new HttpParams();
        // iterate over object keys
        for (const key in params)
            if (params.hasOwnProperty(key)) {
                qParams = qParams.set(key, params[key]);
            }

        return qParams;
    }

    private getRequestOption(formEncoded: boolean) {
        let headers: HttpHeaders = this.headers;
        if (formEncoded) {
            headers = headers.set('AUTHORIZATION', 'ApiKey jnadmin:bcb9df6a2cc2f2c8944c3820fe6bdc5954d1facb');
        } else {
            headers = headers.set('AUTHORIZATION', 'ApiKey jnadmin:bcb9df6a2cc2f2c8944c3820fe6bdc5954d1facb');
        }
        return {
            headers: headers,
        };
    }
}
